import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const photoSrc = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url);

export const errMsg = (e, fallback = "A apărut o eroare. Încearcă din nou.") => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const deviceId = () => {
  let id = localStorage.getItem("device_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Math.random()).slice(2);
    localStorage.setItem("device_id", id);
  }
  return id;
};

export const authed = async (getToken) => ({ headers: { Authorization: `Bearer ${await getToken()}` } });

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" });

export default axios;
